import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Container, Heading } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { withLazyLoading } from '@grandvisionhq/utils';
import { ProductPromotionEventProvider } from '../../DataLayer/Contexts/ProductPromotionEventContext.js';
import ProductBanner from '../ProductBanner/ProductBannerContainer.js';

var FeaturedProducts = (_param)=>{
    var { title , renderLocation  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "title",
        "renderLocation"
    ]);
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(ProductPromotionEventProvider, {
        location: `featured reccommendation ${renderLocation}`
    }, /*#__PURE__*/ React.createElement("div", {
        className: "featured-products"
    }, /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(Heading, {
        className: "featured-products__title",
        variant: "medium",
        align: "center"
    }, title || getLabel('products.featured.title')), /*#__PURE__*/ React.createElement(ProductBanner, swcHelpers.extends({}, rest)))));
};
var FeaturedProducts$1 = withLazyLoading(FeaturedProducts);

export { FeaturedProducts, FeaturedProducts$1 as default };
//# sourceMappingURL=FeaturedProducts.js.map
